import { Component, Input, OnInit} from '@angular/core';
import { ControleAgendamentoProcessoHonraBatch } from 'src/app/model/controle-agendamento-processo-batch.model';
import { AcompanhamentoBatchPesquisaComponent } from '../acompanhamento-batch-pesquisa/acompanhamento-batch-pesquisa.component';

@Component({
    selector: 'app-acompanhamento-batch-listagem',
    templateUrl: './acompanhamento-batch-listagem.component.html',
    styleUrls: ['./acompanhamento-batch-listagem.component.scss'],
    standalone: false
})
export class AcompanhamentoBatchListagemComponent {
  // public execucaoRealizadaComSucessoTrue: number = 0;
  // public controleAgendamentoProcessoHonraBatchLength: number;
  // public logsExecucaoLength: number;
  // public progresso: number;
  @Input() public controleAgendamentoProcessoHonraBatch: ControleAgendamentoProcessoHonraBatch;



  // calculaProgresso(){
  //   this.controleAgendamentoProcessoHonraBatchLength = Object.keys(this.controleAgendamentoProcessoHonraBatch).length
  //   for (var i=0; i<this.controleAgendamentoProcessoHonraBatchLength;i++){
  //     this.controleAgendamentoProcessoHonraBatch[i].sucesso == true? this.execucaoRealizadaComSucessoTrue++ : ''
  //   }
  //   this.progresso = ((this.execucaoRealizadaComSucessoTrue / this.controleAgendamentoProcessoHonraBatchLength) * 100); 
  //   this.progresso = Math.round(this.progresso)
  // }

  // ngOnInit(): void {
  //     this.calculaProgresso()
  //     console.log("controleAgendamentoProcessoHonraBatchLength: "+ this.controleAgendamentoProcessoHonraBatchLength)
  //     console.log("execucaoRealizadaComSucessoTrue: "+ this.execucaoRealizadaComSucessoTrue)
  //     console.log("progresso: "+ this.progresso)
  // }


}